<template>
    <!--
      BLOCO S — item 36: renderiza os campos personalizados DEFINIDOS para uma entidade.

      A tela não sabe quais campos existem — pergunta ao backend, que responde com a
      definição (tipo, obrigatoriedade, opções, tamanho). A validação real acontece no
      Service; o que se faz aqui é conveniência de digitação.

      Campo personalizado é cadastro complementar e não participa de nenhum cálculo
      acadêmico — por isso este componente é isolado e não conversa com o formulário
      principal da entidade.
    -->
    <div>
        <div v-if="carregando" class="u-text-center u-mt-10">Carregando campos...</div>

        <el-alert v-else-if="erro" :title="erro" type="warning" :closable="false"></el-alert>

        <el-alert v-else-if="!campos.length" type="info" :closable="false"
                  title="Nenhum campo personalizado definido para esta funcionalidade."></el-alert>

        <template v-else>
            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col v-for="c in campos" :key="c.id" :xs="24" :sm="12">
                        <el-form-item :label="c.rotulo + (c.obrigatorio ? ' *' : '')">
                            <el-input v-if="c.tipo === 'texto'" v-model="valores[c.chave]"
                                      :maxlength="c.tamanho_max || 500"></el-input>
    
                            <el-input v-else-if="c.tipo === 'numero'" v-model="valores[c.chave]"
                                      type="number"></el-input>
    
                            <el-date-picker v-else-if="c.tipo === 'data'" v-model="valores[c.chave]"
                                            type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                                            style="width: 100%;"></el-date-picker>
    
                            <el-select v-else-if="c.tipo === 'selecao'" v-model="valores[c.chave]"
                                       clearable style="width: 100%;">
                                <el-option v-for="(o, i) in c.opcoes" :key="i" :label="o" :value="o"></el-option>
                            </el-select>
    
                            <el-select v-else-if="c.tipo === 'booleano'" v-model="valores[c.chave]"
                                       clearable style="width: 100%;">
                                <el-option label="Sim" value="1"></el-option>
                                <el-option label="Não" value="0"></el-option>
                            </el-select>
    
                            <el-input v-else v-model="valores[c.chave]"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="erroSalvar" :title="erroSalvar" type="error" :closable="false" class="u-mb-10"></el-alert>

            <div class="u-text-right">
                <el-button type="primary" size="small" :loading="salvando" @click="salvar()">
                    SALVAR CAMPOS PERSONALIZADOS
                </el-button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        entidade: { type: String, required: true },
        registroId: { default: null }
    },
    data: () => ({
        campos: [],
        valores: {},
        carregando: false,
        salvando: false,
        erro: '',
        erroSalvar: ''
    }),
    watch: {
        registroId: 'carregar'
    },
    mounted () {
        this.carregar()
    },
    methods: {
        carregar () {
            this.campos = []
            this.valores = {}
            this.erro = ''
            this.erroSalvar = ''

            // Sem registro salvo ainda não há onde pendurar valor.
            if (!this.registroId) return

            this.carregando = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/campo-personalizado/valores/${this.entidade}/${this.registroId}`,
                            this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                const d = r.data || {}

                if (d.erro || d.error) { this.erro = d.erro || d.error; return }

                this.campos = d.campos || []

                const v = {}
                this.campos.forEach(c => { v[c.chave] = c.valor })
                this.valores = v
            }).catch(e => { this.carregando = false; this.tratarFalha(e, 'erro') })
        },

        salvar () {
            this.erroSalvar = ''
            this.salvando = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/campo-personalizado/valores/${this.entidade}/${this.registroId}`,
                             { valores: this.valores }, this.$store.getters.getHeaderAuth).then(r => {
                this.salvando = false
                const d = r.data || {}

                // Só anuncia sucesso após ler a resposta — o backend recusa tipo/obrigatoriedade.
                if (d.erro || d.error) { this.erroSalvar = d.erro || d.error; return }

                this.$message.success(d.mensagem || 'Campos salvos.')
                this.campos = d.campos || this.campos
                this.$emit('salvo', d)
            }).catch(e => { this.salvando = false; this.tratarFalha(e, 'erroSalvar') })
        },

        tratarFalha (e, campo) {
            const d = (e && e.response && e.response.data) ? e.response.data : {}
            this[campo] = d.erro || d.error || 'Não foi possível carregar os campos personalizados.'
        }
    }
}
</script>
